import ListOrdersWrap from './ListOrdersWrap';
export default ListOrdersWrap;



// WEBPACK FOOTER //
// ./src/pages/SubmissionCrmErrorsPage/components/ListOrders/index.ts